import Image from '@/models/image';
import assetsUtils from '@/utils/url.utils';

export default class TransactionProduct {
  public id: string;
  public title: string;
  public image: Image = new Image();
  public cost: number;
  public weight: string;
  public count: number;

  public constructor(transactionProductProps: any) {
    this.id = transactionProductProps.id;
    this.title = transactionProductProps.title;
    this.image = transactionProductProps.image;
    this.cost = transactionProductProps.cost;
    this.weight = transactionProductProps.weight;
    this.count = transactionProductProps.count;
  }

  get preview(): URL {
    if (this.image && this.image.original && this.image.path) {
      return assetsUtils.generateAssetsUrl(this.image.path);
    }

    return require('../assets/images/product-placeholder.png');
  }
}
